import React, {useEffect, useState} from 'react';
import {Grid, Paper} from "@mui/material";
import {styled} from "@mui/material/styles";
import {baseUrl_back} from "../../api/BaseUrl";
import BackServer from "../../api/BackServer";
import OneCategoryGlassNew from "../OneCategoryGlassNew/OneCategoryGlassNew";
import {MDBBtn, MDBSpinner} from "mdb-react-ui-kit";


const Item = styled(Paper)(({theme}) => ({
    // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    // ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const CategoryName = styled(Paper)(({theme}) => ({
    // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    // ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.primary,
}));

const CategoryName2 = styled(Paper)(({theme}) => ({
    // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    // ...theme.typography.body2,

    padding: theme.spacing(0),
    textAlign: 'center',
    color: theme.palette.text.primary,
}));


const Categories = (props) => {
    const [categories, setCategories] = useState([])
    const [kolXl, setkolXL]= useState(2)
    const [interval, setinterval]= useState(2)
    const getCategories = async () => {
        const response = await BackServer.GetCategories()
        // alert(JSON.stringify(response.message.Categories));

        setCategories(response.message.Categories)
    }
    function xchange(event) {
        setkolXL(event.target.value)
    }
    function ychange(event) {
        setinterval(event.target.value)
    }
    useEffect(() => {
        getCategories()
    }, [])

    if (categories.length<1){
        return (

            <div className='d-flex justify-content-center'>
                <MDBBtn color='danger' disabled>
                    <MDBSpinner  size='sm' role='status' tag='span' className='me-2' />
                    Загрузка категорий...
                </MDBBtn>
            </div>

        )}

    return (
        <>

            {/*{JSON.stringify(categories)}*/}
            <div className={"paddingTop15"}>
                <Grid container spacing={interval}>
                    {categories.map((elm, key) => (
                            // <Grid  key={key}  item xs={6} md={2.4}  sm={3} lg={2.4} xl={2}>
                           <Grid item key={key}  lg={2} xl={2} sm={4} md={3} xs={12}>
                                {/*<OneCategory  label={elm.name} img={baseUrl_back+elm.imageUrl}  urlx={elm.Url}></OneCategory>*/}
                                {/*<OneCategoryGlass key={key} label={elm.name} img={baseUrl_back+elm.imageUrl}  urlx={elm.Url}/>*/}
                                <OneCategoryGlassNew key={key} label={elm.name} img={baseUrl_back+elm.imageUrl}  urlx={elm.Url}/>
                            </Grid>
                    ))}
                    {/*<SizeTest></SizeTest>*/}
                    {/*<Slider*/}
                    {/*    aria-label="Small steps"*/}
                    {/*    defaultValue={1.00}*/}
                    {/*    value={kolXl}*/}
                    {/*    onChange={xchange}*/}
                    {/*    // getAriaValueText={kolXl*/}
                    {/*    step={0.05}*/}
                    {/*    marks*/}
                    {/*    min={0.1}*/}
                    {/*    max={12}*/}
                    {/*    valueLabelDisplay="auto"*/}
                    {/*/>*/}
                    {/*<Slider*/}
                    {/*    aria-label="Small steps"*/}
                    {/*    defaultValue={1.00}*/}
                    {/*    value={interval}*/}
                    {/*    onChange={ychange}*/}
                    {/*    // getAriaValueText={kolXl*/}
                    {/*    step={0.05}*/}
                    {/*    marks*/}
                    {/*    min={0.1}*/}
                    {/*    max={12}*/}
                    {/*    valueLabelDisplay="auto"*/}
                    {/*/>*/}

                </Grid>
            </div>

        </>
    );
};

export default Categories;